var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16227",
    "data-name": "Rectangle 16227",
    width: 20,
    height: 20,
    transform: "translate(21 541)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_14",
    "data-name": "Mask Group 14",
    transform: "translate(-21 -541)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(19 539)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1722",
    d: "M11.824,4a.692.692,0,0,0-.48.2L3.2,12.343a.692.692,0,0,0-.2.489v2.937a.692.692,0,0,0,.692.692H6.63a.692.692,0,0,0,.489-.2l8.14-8.14a.692.692,0,0,0,0-.979L12.323,4.2a.692.692,0,0,0-.5-.2Zm.01,1.671,1.958,1.958L6.344,15.077H4.386V13.119Z",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#21988c",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1724",
    d: "M13.133,18a.693.693,0,0,0-.476.209L9.478,21.386A2.038,2.038,0,0,0,9,22.157H3.7a.692.692,0,1,0,0,1.383H9a2.036,2.036,0,0,0,.481.779,2.09,2.09,0,0,0,2.938,0l1.959-1.957a1.757,1.757,0,0,0,.4.574,2.089,2.089,0,0,0,2.937,0l.787-.786H20.3a.692.692,0,1,0,0-1.383H18.217a.693.693,0,0,0-.489.2l-.99.989a.692.692,0,1,1-.979-.978l.41-.409a.692.692,0,0,0-.979-.978L14.78,20l-3.343,3.339a.692.692,0,0,1-.98-.978l3.179-3.176a.692.692,0,0,0-.5-1.187Z",
    transform: "translate(0 -4.308)",
    fill: "#fff",
    stroke: "#21988c",
    strokeWidth: 0.1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignWhite);
export default __webpack_public_path__ + "static/media/sign-white.67a23fbab8be5052ba65d2ad94a4c537.svg";
export { ForwardRef as ReactComponent };